module["exports"] = [
  "ون",
  "کوپه",
  "پیکاپ",
  "مینی ون",
  "ون مسافرتی",
  "شاسی بلند",
  "سدان",
  "استیشن"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/vehicle/vehicle_type.js
// module id = 2916
// module chunks = 1609